import * as React from 'react';
import styled from 'styled-components';
import { colors } from '@omilia/theme';
import { getThemeProp } from 'styles/theme';
import { useTranslation } from '@omilia/providers';

const SContainer = styled.div`
  border-bottom: 1px solid ${getThemeProp('primaryColor')};
  color: ${getThemeProp('primaryColor')};
  margin-bottom: 24px;
  position: relative;
`;

const SLabel = styled.span`
  background-color: ${colors.COLOR_WHITE};
  font-size: 0.7rem;
  left: 0;
  line-height: 1;
  padding: 10px 10px 10px 0;
  position: absolute;
  top: -16px;
  z-index: 1;
`;

const Divider = () => {
  const { t } = useTranslation();

  return (
    <SContainer>
      <SLabel>{t('session.endOfSession')}</SLabel>
    </SContainer>
  );
};

export default Divider;
